import * as types from "../constants/actionTypes";
import * as tools from "../helpers/Tools";



export const localCacheInitialState = {
    ProviderDetailList: null,
};

export default function localCacheReducer(state = localCacheInitialState, action) {
    switch (action.type) {
        case types.SET_PROVIDER_DETAILS_FROM_NPI_LIST:
            return { ...state, ProviderDetailList: action.arrayProviders };
        default:
            return { ...state };

    }
};
